import React from "react";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import { Alert, Grid, List, Typography } from "@mui/material";
import { useState } from "react";
import { UpdateUserPasswordApi } from "backendServices/ApiCalls";
import * as yup from "yup";
import { Form, Formik } from "formik";
import Div from "@jumbo/shared/Div/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  getPasswordResetErrorMessage,
  PASSWORD_POLICY_HELP,
  passwordValidationSchema,
} from "app/pages/auth-pages/reset-password/resetPasswordPolicy";

export const updateUserPasswordValidationSchema = yup.object({
  user_name: yup.string().required("User name is Required"),
  password: passwordValidationSchema,
  confirm_password: yup
    .string()
    .strict(true)
    .typeError("Confirm password must be a string")
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  admin_transaction_password: yup
    .string()
    .strict(true)
    .typeError("Admin transaction password must be a string")
    .required("Admin transaction password is required"),
});

const Updateuserpassword = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [alertData, setalertData] = useState({
    show: false,
    message: "",
    severity: "error",
  });

  const user_id = location.state?.id || "";
  const username = location.state?.username || "";

  const handleSubmit = (data, setSubmitting, resetForm) => {
    setalertData({ show: false, message: "", severity: "error" });
    let params = {
      userid: user_id,
      password: data.password,
      confirmpassword: data.confirm_password,
      admintransactionpassword: data.admin_transaction_password,
    };

    UpdateUserPasswordApi(
      params,
      (response) => {
        if (response?.data?.status === "error") {
          setalertData({
            show: true,
            message: getPasswordResetErrorMessage(response),
            severity: "error",
          });
          setSubmitting(false);
        } else if (response?.data?.status === "success") {
          setalertData({
            show: true,
            message: response?.data?.message,
            severity: "success",
          });
          setSubmitting(false);
          resetForm();
        } else {
          setalertData({
            show: true,
            message: "Something went wrong please try again later",
            severity: "error",
          });
          setSubmitting(false);
        }
      },
      (error) => {
        setalertData({
          show: true,
          message: getPasswordResetErrorMessage(error),
          severity: "error",
        });
        setSubmitting(false);
      }
    );
  };

  return (
    <Grid
      container
      fullWidth
      sm={12}
      xs={12}
      p={2}
      alignItems="center"
      justifyContent="center"
    >
      <Grid item sm={6} xs={12}>
        <JumboCardQuick title={t("pages.title.userpassword")} noWrapper>
          {alertData.show && (
            <Alert
              severity={alertData.severity}
              role="alert"
              onClose={() =>
                setalertData({ show: false, message: "", severity: "error" })
              }
              sx={{ m: 2, mb: 0 }}
            >
              {alertData.message}
            </Alert>
          )}
          <List disablePadding sx={{ mb: 2 }}>
            <Formik
              validateOnChange={true}
              initialValues={{
                user_name: username,
                password: "",
                confirm_password: "",
                admin_transaction_password: "",
              }}
              validationSchema={updateUserPasswordValidationSchema}
              onSubmit={(data, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                handleSubmit(data, setSubmitting, resetForm);
              }}
            >
              {({ isSubmitting }) => (
                <Form
                  style={{ textAlign: "left" }}
                  noValidate
                  autoComplete="off"
                >
                  <Div sx={{ mt: 1, mb: 3, pl: 2, pr: 2 }}>
                    <JumboTextField
                      fullWidth
                      name="user_name"
                      label="Select a User"
                      type="text"
                      disabled={true}
                    />
                  </Div>
                  <Div sx={{ mt: 1, mb: 3, pl: 2, pr: 2 }}>
                    <JumboTextField
                      fullWidth
                      id="admin-user-new-password"
                      name="password"
                      label="New Password"
                      type="password"
                      autoComplete="new-password"
                      required
                      inputProps={{
                        "aria-describedby":
                          "admin-user-password-policy admin-user-new-password-helper-text",
                      }}
                    />
                    <Typography
                      id="admin-user-password-policy"
                      variant="body2"
                      sx={{ mt: 1, color: "text.secondary" }}
                    >
                      {PASSWORD_POLICY_HELP}
                    </Typography>
                  </Div>

                  <Div sx={{ mt: 1, mb: 3, pl: 2, pr: 2 }}>
                    <JumboTextField
                      fullWidth
                      id="admin-user-confirm-password"
                      name="confirm_password"
                      label="Confirm Password"
                      type="password"
                      autoComplete="new-password"
                      required
                    />
                  </Div>

                  <Div sx={{ mt: 1, mb: 3, pl: 2, pr: 2 }}>
                    <JumboTextField
                      fullWidth
                      id="admin-user-transaction-password"
                      name="admin_transaction_password"
                      label="Admin transaction Password"
                      type="password"
                      autoComplete="current-password"
                      required
                    />
                  </Div>

                  <Div sx={{ mt: 1, pl: 2, pr: 2 }}>
                    <LoadingButton
                      fullWidth
                      type="submit"
                      variant="contained"
                      size="large"
                      sx={{ mb: 3 }}
                      loading={isSubmitting}
                    >
                      {t("pages.title.submit")}
                    </LoadingButton>

                    {/* <Button type="button" onClick={test}>click me</Button> */}
                  </Div>
                </Form>
              )}
            </Formik>
          </List>
        </JumboCardQuick>
      </Grid>
    </Grid>
  );
};

export default Updateuserpassword;
